import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import { selectDbaTypesCreatedItem, selectDbaTypesListItems, selectDbaTypesUpdatedItem } from "../../../../../../redux/dbn-cloud/dba-types/selector";
import { dbaTypes } from "../../../../../../redux/dbn-cloud/dba-types/action";

const DBAMappedWebsitesInfoComponent = ({ selectedDba, websites }) => {
  const dispatch = useAppDispatch();
  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const dbasItems = useSelector(selectDbaTypesListItems);
  const dbaCreateItems = useSelector(selectDbaTypesCreatedItem);
   const dbaUpdateItems = useSelector(selectDbaTypesUpdatedItem);
  const [columnDefs, setColumnDefs] = useState({});

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    Id: null,
    TenantWebsiteId: "",
    HostingUrl: "",
    FQDNName: "",
    DisplayOrder: "",
  });

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: "Sl",
        headerName: "Sl",
        cellRenderer(params: any) {
          return parseInt(params.node.id, 10) + 1;
        },
      },
      { field: "DBAName", headerName: "DBA Name", filterType: "text" },
      { field: "TenantWebsiteName", headerName: "Tenant Website Name", filterType: "text" },
      { field: "FQDNName", headerName: "FQDN Name" },
      { field: "HostingUrl", headerName: "Hosting URL" },
      { field: "DisplayOrder", headerName: "Display Order" },
    ]);
  };

  const fetchDBASist = () => {
    dispatch(
      dbaTypes.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-website-mappings/list`,
        entity: "dbaTypes",
        jsonData: {
          PageNumber: pageData,
          PageSize: pageSize,
          SortField: "Id",
          SortOrder: "desc",
        },
      })
    );
  };

  useEffect(() => {
    if (dbaCreateItems?.isSuccess) {
      fetchDBASist();
    }
  }, [dbaCreateItems]);

   useEffect(() => {
    if (dbaUpdateItems?.isSuccess) {
      fetchDBASist();
    }
  }, [dbaUpdateItems]);

  useEffect(() => {
    createColumnDefs();
    fetchDBASist();
  }, [pageData, pageSize]);

  const handleAdd = () => {
    setFormData({
      Id: null,
      TenantWebsiteId: "",
      HostingUrl: "",
      FQDNName: "",
      DisplayOrder: "",
    });
    setShowModal(true);
  };

  const handleEdit = (data: any) => {
    setFormData({
      Id: data?.Id,
      TenantWebsiteId: data?.TenantWebsiteId || "",
      HostingUrl: data?.HostingUrl || "",
      FQDNName: data?.FQDNName || "",
      DisplayOrder: data?.DisplayOrder || "",
    });
    setShowModal(true);
  };

  const handleDelete = (data: any) => {
    dispatch(
      dbaTypes.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-website-mappings/delete`,
        entity: "dbaTypes",
        jsonData: {
          Context: {},
          Records: [{ Id: data?.Id }],
        },
      })
    ).then(() => {
      fetchDBASist();
    });
  };

  const handleSave = () => {
    const selectedWebsite = websites?.find(
      (w: any) => w?.Id === Number(formData.TenantWebsiteId)
    );

    const payload = {
      Id: formData.Id || 0, // if editing, include Id
      DBAId: selectedDba?.DBAId || 0,
      DBAName: selectedDba?.Name || "",
      TenantWebsiteId: Number(formData.TenantWebsiteId) || 0,
      TenantWebsiteName: selectedWebsite?.WebSiteName || "",
      FQDNName: formData.FQDNName || "",
      HostingUrl: formData.HostingUrl || "",
      DisplayOrder: Number(formData.DisplayOrder) || 0,
    };

    if(formData.Id >0 )
    {
 dispatch(
      dbaTypes.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-website-mappings`,
        entity: "dbaTypes",
        jsonData: {
          Context: {},
          Records: [payload],
        },
      })
    );
    }
    else{
    dispatch(
      dbaTypes.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-website-mappings`,
        entity: "dbaTypes",
        jsonData: {
          Context: {},
          Records: [payload],
        },
      })
    );
  }
    setShowModal(false);
  };

  const additionButtons: any = [
    {
      svg: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Website Details</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" strokeWidth="2" fill="none" />
        </svg>
      ),
      callback: () => handleAdd(),
    },
  ];

  return (
    <>
      {dbasItems?.isLoading ? (
        <PageLoader />
      ) : (
        <Table
            columnData={columnDefs}
            rowData={dbasItems?.result?.items}
            setPageData={setPageData}
            setPageSize={setPageSize}
            paginationData={dbasItems?.result?.pagination}
            additionButtons={additionButtons}
            headingName="Websites"
            onEdit={handleEdit}
            onDelete={handleDelete} checkboxConfig={undefined}        />
      )}

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white w-1/2 max-h-[80vh] rounded-lg shadow-lg flex flex-col">
            {/* Header */}
            <div className="p-6 border-b">
              <h2 className="text-lg font-bold">
                {formData.Id ? "Edit Website Details" : "Add Website Details"}
              </h2>
            </div>

            {/* Body */}
            <div className="p-6 overflow-y-auto">
              {/* Websites Dropdown */}
              <label className="block font-medium mb-1">Website Name</label>
              <select
                value={formData.TenantWebsiteId}
                onChange={(e) => setFormData({ ...formData, TenantWebsiteId: e.target.value })}
                className="border w-full p-2 mb-4"
              >
                <option value="">Select Website</option>
                {websites?.map((website: any) => (
                  <option key={website?.Id} value={website?.Id}>
                    {website?.WebSiteName}
                  </option>
                ))}
              </select>

              {/* Hosting URL */}
              <label className="block font-medium mb-1">Hosting URL</label>
              <input
                type="text"
                value={formData.HostingUrl}
                onChange={(e) => setFormData({ ...formData, HostingUrl: e.target.value })}
                className="border w-full p-2 mb-4"
              />

              {/* FQDN Name */}
              <label className="block font-medium mb-1">FQDN Name</label>
              <input
                type="text"
                value={formData.FQDNName}
                onChange={(e) => setFormData({ ...formData, FQDNName: e.target.value })}
                className="border w-full p-2 mb-4"
              />

              {/* Display Order */}
              <input
                type="number"
                placeholder="Display Order"
                value={formData.DisplayOrder}
                onChange={(e) => setFormData({ ...formData, DisplayOrder: e.target.value })}
                className="border w-full p-2 mb-4"
              />
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-3 p-6 border-t">
              <button className="px-4 py-2 bg-gray-300 rounded" onClick={() => setShowModal(false)}>
                Cancel
              </button>
              <button className="px-4 py-2 bg-blue-600 text-white rounded" onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};


export default DBAMappedWebsitesInfoComponent;
